export default __webpack_public_path__ + "static/media/arrow_metrics-show.4b8dda07.svg";